import { useEffect, useState } from "react";
import { DataTable } from "@/components/fleet/DataTable";
import { api, fmtDate } from "@/lib/api";

const ROLE_CLS = {
  admin: "bg-amber-100 text-amber-800",
  company: "bg-blue-100 text-blue-800",
  driver: "bg-indigo-100 text-indigo-800",
  customer: "bg-slate-100 text-slate-700",
};

export const UsersPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/users").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  return (
    <DataTable
      testId="users-table"
      rows={rows}
      cols={[
        ["Name", (u) => <span className="font-semibold text-slate-900">{u.name}</span>],
        ["Email", (u) => u.email],
        ["Phone", (u) => u.phone || "—"],
        ["Role", (u) => <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${ROLE_CLS[u.role]}`}>{u.role === "company" ? "Comfort Taxi staff" : u.role}</span>],
        ["Joined", (u) => fmtDate(u.created_at)],
      ]}
    />
  );
};
